// import React, { useState, memo, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import { store } from "store/index";
// import API, { base } from "api.js";
// import useLogOut from "hooks/useLogOut";
// import AvatarImg from "assets/images/images_new/avatar.png";
// import Bell from "components/Notification/Bell";
// import CollapseIcon from "assets/images/images_new/dropdown-icon.svg";
// import CursorIcon from "assets/images/images_new/cursor-icon.png";
// import SubscriptionIcon from "assets/images/images_new/subscription-icon.svg";
// import GoldIcon from "assets/images/images_new/diamond-icon.svg";
// import {
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from 'reactstrap';
// import { encode as base64_encode } from 'base-64';

// const DashboardHeader = memo(function DashboardHeader({ title, sutitle }) {

//     const history = useHistory();
//     const { logout } = useLogOut();

//     const { user } = store.getState();

//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [subscriptions, setSubscriptions] = useState([]);

//     const toggle = () => setDropdownOpen((prevState) => !prevState);

//     const openCloseSidebarMobile = () => {
//   		if (document.body.classList.contains('leftSidebarClosed')) {
//   			document.body.classList.remove('openSidebar');
//   		} else {
//   			document.body.classList.add('openSidebar');
//   		}
//   	}

//     const fullName = () => {
//       const { first_name, last_name, email } = user;
//       let full_name = "";

//       if (first_name !== "" && first_name !== null && first_name !== undefined) {
//         full_name = `${first_name}`;
//       }

//       if (last_name !== "" && last_name !== null && last_name !== undefined) {
//         full_name = `${full_name} ${last_name}`;
//       }

//       if (full_name === "") {
//         full_name = email;
//       }

//       return full_name;
//     }

//     const profilePic = () => {
//       let img_url = AvatarImg;
//       if (user.image) {
//         img_url = `${base}${user.image}`;
//       }

//       return img_url;
//     }

//     const naviagteTo = (url) => {
//       history.push('/admin/profile');
//     }

//     const handleOperation = (e, page) => {
//       e.preventDefault();

//       switch(page) {
//         case "profile":
//           naviagteTo('/admin/profile');
//           break;
//         case "logout":
//           logout();
//           break;
//         default:
//           break;
//       }
//     }

//     /**
//      * Redirect to pte core.
//      */
//     const redirectNow = (token_id) => {
//       const PTE_CORE_URL = import.meta.env.VITE_PTE_CORE_URL;
//       const encoded_token_id = base64_encode(token_id);
//       const pte_core = `${PTE_CORE_URL}default/check/post?cust=${encoded_token_id}`;
//       window.location.href = pte_core; // redirect to pte core website.
//     }

//     /**
//      * Process data to redirect to pte core.
//      */
//     const redirectToPteCore = () => {
//       const { user: { id, email, token: access_token }, token } = store.getState();

//       if (access_token !== undefined && access_token !== null && access_token.length > 0) {
//         redirectNow(access_token[0].id);

//       } else {
//         // get id.
//         API({
//           url: "token/id",
//           method: "GET"
//         }).then((res) => {
//           redirectNow(res.data.data);
//         }).catch(err => console.log(err));
//       }
//     }

//     useEffect(() => {
//       const { user: { active_subscription } } = store.getState();
//       setSubscriptions(active_subscription);
//     }, []);

//     return (
//       <>
//         <div className="dasboard-head">
//           <div className="d-flex align-items-center">
//             <span className="toggleIcon openSidebarMobile align-self-center pr-3" onClick={() => openCloseSidebarMobile()}>
//     				  <img src="/images/new_dash/hamburger.png" alt="collapse icon" />
//     			  </span>
//             <h2 className="title">{title} {sutitle}</h2>
//           </div>
//           <div className="user-info-content">
//             <div>
//               <a
//                 href="javascript:void(0)"
//                 onClick={redirectToPteCore}
//                 className="pte-core-btn cursor-pointer"
//               >
//                 <img src={CursorIcon} alt="Go to PTE CORE" /> Go to PTE CORE
//               </a>
//             </div>

//             {user.center &&
//               <div className="user-branch ms-3">
//                 <span className="outline-badge">{user.center}</span>
//               </div>
//             }

//             <div className="subscription-icon" data-bs-toggle="modal" data-bs-target="#exampleModal">
//               <img src={SubscriptionIcon} alt="LA" />
//             </div>

//             <div className="user-notification">
//               <Bell />
//             </div>

//             <div className="user-info">
//               <div className="user-img">
//                 <img src={profilePic()} alt="LA" />
//               </div>
//               <div className="user-dropdown-wrapper">
//                 <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
//                   <DropdownToggle tag="span" className="badge-dropdown badge-profile cursor-pointer">{fullName()}</DropdownToggle>
//                   <DropdownMenu>
//                     {/*<DropdownItem>{fullName()}</DropdownItem>*/}
//                     <DropdownItem
//                       onClick={(e) => handleOperation(e, "profile")}
//                     >My Profile</DropdownItem>
//                     <DropdownItem divider />
//                     <DropdownItem
//                       onClick={(e) => handleOperation(e, "logout")}
//                     >Logout</DropdownItem>
//                   </DropdownMenu>
//                 </Dropdown>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* subscription Modal HTML */}
//         <div className="modal fade subscription-popup" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//           <div className="modal-dialog">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h1
//                   className="modal-title adjustment fs-5"
//                   id="exampleModalLabel"
//                 >My Subscription(s)</h1>

//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body p-0">
//                 <div className="sub-popup-card">
//                   <h2 className="sub-popup-title">Active Subscription Plan</h2>
//                   <ul className="sub-popup-content">
//                     <li>Plan <span>Expiry</span></li>

//                     {subscriptions.length > 0 ? (
//                       <>
//                         {subscriptions.map((item, i) => {
//                           return (
//                             <li key={i}>
//                               <span className="gold-btn">
//                                 <img src={GoldIcon} alt="LA" /> {item.plan.title}
//                               </span> <span>{item.expiry_date}</span>
//                             </li>
//                           )
//                         })}

//                         <li>
//                           <a
//                             href='/admin/plans'
//                             className="btn btn-block"
//                           >Upgrade Plan</a>
//                         </li>
//                       </>
//                     ) : (
//                       <li>
//                         <a
//                           href='/admin/plans'
//                           className="btn btn-block"
//                         >Buy a plan</a>
//                       </li>
//                     )}
//                   </ul>
//                 </div>

//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
// });
// export default DashboardHeader;

import React, { useState, memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { store } from "store/index";
import API, { base, base_new } from "api.js";
import useLogOut from "hooks/useLogOut";
import AvatarImg from "assets/images/images_new/avatar.png";
import Bell from "components/Notification/Bell";
import CollapseIcon from "assets/images/images_new/dropdown-icon.svg";
import CursorIcon from "assets/images/images_new/cursor-icon.png";
import SubscriptionIcon from "assets/images/images_new/subscription-icon.svg";
import BackArrow from "assets/images/images_new/back-arrow.svg";
import GoldIcon from "assets/images/images_new/diamond-icon.svg";
import ConfirmLogoutModal from "components/Auth/ConfirmLogoutModal.jsx";
import { Dropdown } from 'react-bootstrap';
import "components/dropdown.css";
import { encode as base64_encode } from "base-64";

const DashboardHeader = memo(function DashboardHeader({
  title,
  sutitle,
  avatar,
}) {
  const navigate = useNavigate();
  const { logout } = useLogOut();
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen((prev) => !prev);
  const { user } = store.getState();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const openCloseSidebarMobile = () => {
    if (document.body.classList.contains("leftSidebarClosed")) {
      document.body.classList.remove("openSidebar");
    } else {
      document.body.classList.add("openSidebar");
    }
  };

  const fullName = () => {
    const { first_name, last_name, email } = user;
    let full_name = "";

    if (first_name !== "" && first_name !== null && first_name !== undefined) {
      full_name = `${first_name}`;
    }

    if (last_name !== "" && last_name !== null && last_name !== undefined) {
      full_name = `${full_name} ${last_name}`;
    }

    if (full_name === "") {
      full_name = email;
    }

    return full_name;
  };

  const profilePic = () => {
    let img_url = AvatarImg;
    if (
      user.image.includes("/storage/male.png") ||
      user.image.includes("/storage/female.png")
    ) {
      img_url = `${base_new}${user.image}`;
    } else {
      img_url = `${base_new}${user.image}`;
    }

    return img_url;
  };

  const navigateTo = (url) => {
    navigate(url);
  };

  const handleOperation = (e, page) => {
    e.preventDefault();
    // console.log("page===", page);

    switch (page) {
      case "profile":
        navigateTo("/admin/profile");
        break;
      case "changepassword":
        navigateTo("/admin/password");
        break;
      case "logout":
        toggleModal();
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigateTo("/admin/dashboard");
    }
  };

  /**
   * Redirect to pte core.
   */
  const redirectNow = (token_id) => {
    const PTE_LA_URL = import.meta.env.VITE_LA_URL;
    const encoded_token_id = base64_encode(token_id);
    const pte_core = `${PTE_LA_URL}/admin/dashboard`;
    window.location.href = pte_core; // redirect to pte core website.
  };

  /**
   * Process data to redirect to pte core.
   */
  const redirectToPteCore = () => {
    const {
      user: { id, email, token: access_token },
      token,
    } = store.getState();

    if (
      access_token !== undefined &&
      access_token !== null &&
      access_token.length > 0
    ) {
      redirectNow(access_token[0].id);
    } else {
      // get id.
      API({
        url: "token/id",
        method: "GET",
      })
        .then((res) => {
          redirectNow(res.data.data);
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    const {
      user: { active_subscription },
    } = store.getState();
    setSubscriptions(active_subscription);
  }, []);

  return (
    <>
      <div className="dasboard-head">
        <div className="d-flex align-items-center gap-1">
          <span
            className="toggleIcon openSidebarMobile align-self-center pr-3"
            onClick={() => openCloseSidebarMobile()}
          >
            <img src="/images/new_dash/hamburger.png" alt="collapse icon" />
          </span>
          {/* Back Arrow */}
          {window.location.pathname !== '/admin/dashboard' &&
            <button
              type="button"
              className="back-arrow px-2 px-lg-0 p-0 border-0 bg-transparent"
              onClick={handleBack}
              aria-label="Go back"
            >
              <img src={BackArrow} alt="Back Arrow" />
            </button>
            
          }
          <h2 className={`title ${window.location.pathname !== '/admin/dashboard' ? "mx-0 mx-md-auto" : ""}`}>
            {title} {sutitle}
          </h2>
        </div>
        <div className="user-info-content">
          <div className="d-none d-md-block">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = `${import.meta.env.VITE_LA_URL}/admin/dashboard`;
              }}
              className="pte-core-btn cursor-pointer"
            >
              <img src={CursorIcon} alt="Go to PTE Academic" /> Go to PTE Academic
            </a>
          </div>

          {user.center && user.center !== "null" && (
            <div className="user-branch ms-2 d-none d-md-block">
              <span className="outline-badge">{user.center}</span>
            </div>
          )}

          <div
            className="subscription-icon d-none-320"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            <img src={SubscriptionIcon} alt="LA" />
          </div>

          <div className="user-notification">
            <Bell />
          </div>
          <div className="user-info">
            <div className="user-img position-relative">
              {user.image ? (
                <img src={profilePic()} alt="LA" className="m-0" />
              ) : (
                <div className="user-initials">
                  {user.first_name?.[0]?.toUpperCase() || ""}
                  {user.last_name?.[0]?.toUpperCase() || ""}
                </div>
              )}
              <div
                className="subscription-icon subscription-badge d-block-320"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                <img src={SubscriptionIcon} alt="LA" />
              </div>
            </div>

            <div className="user-dropdown-wrapper">
              <Dropdown
                show={dropdownOpen}
                onToggle={toggle}
                direction="down"
                id="dropID"
                className="user-dropdown"
              >
                <Dropdown.Toggle
                  // caret={false}
                  as="span"
                  bsPrefix="custom-toggle"
                  className="dropdown-hover user-dropdown-toggle"
                >
                  {/* <span className="d-none d-md-inline">{fullName()}</span>
                  <span className="d-inline d-md-none">
                    <img
                      src={CollapseIcon}
                      alt="menu"
                      className="user-dropdown-icon"
                    />
                  </span> */}
                  <span className="user-display">
                    <span className="user-name d-none d-md-inline">
                      {fullName()}
                    </span>
                    <img
                      src={CollapseIcon}
                      alt="menu"
                      className="user-dropdown-icon"
                    />
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="user-dropdown-menu">
                  <Dropdown.Item onClick={(e) => handleOperation(e, "profile")}>
                    My Profile
                  </Dropdown.Item>

                  {/* Mobile only */}
                  <Dropdown.Item className="d-block d-md-none">
                    <button
                      onClick={() => window.location.href = `${import.meta.env.VITE_LA_URL}/admin/dashboard`}
                      className="pte-dropdown-core-btn"
                    >
                      <img src={CursorIcon} alt="" /> Go to PTE Academic
                    </button>
                    
                  </Dropdown.Item>
                  {user.center && user.center !== "null" && (
                    <Dropdown.Item className="d-block d-md-none">
                      <span className="outline-badge user-center">{user.center}</span>
                       </Dropdown.Item>
                  )}
                  {/* <Dropdown.Item
                    onClick={(e) => handleOperation(e, "changepassword")}
                  >
                    Change Password
                  </Dropdown.Item> */}

                  <Dropdown.Item onClick={(e) => handleOperation(e, "logout")}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      {/* subscription Modal HTML */}
      <div
        className="modal fade subscription-popup"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1
                className="modal-title adjustment fs-5"
                id="exampleModalLabel"
              >
                My Subscription(s)
              </h1>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-0">
              <div className="sub-popup-card">
                <h2 className="sub-popup-title">Active Subscription Plan</h2>
                <ul className="sub-popup-content">
                  <li>
                    Plan <span>Expiry</span>
                  </li>

                  {subscriptions?.[0] ? (
                    <>
                      <li>
                        <span className="gold-btn">
                          <img src={GoldIcon} alt="LA" /> {subscriptions[0]?.plan?.title}
                        </span>{" "}
                        <span>{subscriptions[0].expiry_date}</span>
                      </li>
                      <li>
                        <button
                          className="blockbtn"
                          data-bs-dismiss="modal"
                          onClick={() => navigate("/admin/plans")}
                        >
                          Upgrade Plan
                        </button>
                      </li>
                    </>
                  ) : (
                     <>
                      <li>
                        <span className="text-danger">
                         No active plan
                        </span>
                      </li>
                    <li>
                      <button
                        className="blockbtn"
                        data-bs-dismiss="modal"
                        onClick={() => navigate("/admin/plans")}
                      >
                        Buy a plan
                      </button>
                    </li>
                     </>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ConfirmLogoutModal
          isOpen={modalOpen}
          toggle={toggleModal}
          onConfirm={logout}
        />
      </div>
    </>
  );
});

//   return (
//     <>
//       <div className="dasboard-head">
//         <div className="d-flex align-items-center">
//           <span
//             className="toggleIcon openSidebarMobile align-self-center pr-3"
//             onClick={() => openCloseSidebarMobile()}
//           >
//             <img src="/images/new_dash/hamburger.png" alt="collapse icon" />
//           </span>
//           <h2 className="title">{title} {sutitle}</h2>
//         </div>

//         <div className="user-info-content">
//        <div className="d-flex gap-1 me-2">
//            {/* Always visible PTE Core button */}
//           <div>
//             <a
//               href="javascript:void(0)"
//               onClick={redirectToPteCore}
//               className="pte-core-btn cursor-pointer"
//             >
//               <img src={CursorIcon} alt="Go to PTE CORE" /> Go to PTE CORE
//             </a>
//           </div>

//           {user.center && (
//             <div className="user-branch ms-3">
//               <span className="outline-badge">{user.center}</span>
//             </div>
//           )}

//           {/* === DESKTOP (md and above) === */}
//           <div className="d-none d-md-flex align-items-center gap-2">
//             <div
//               className="subscription-icon"
//               data-bs-toggle="modal"
//               data-bs-target="#exampleModal"
//             >
//               <img src={SubscriptionIcon} alt="Subscription" />
//             </div>

//             <div className="user-notification">
//               <Bell />
//             </div>

//             <div className="user-info">
//               <div className="user-img">
//                 {user.image ? (
//                   <img src={profilePic()} alt="Profile" />
//                 ) : (
//                   <div className="user-initials">
//                     {user.first_name?.[0]?.toUpperCase() || ""}
//                     {user.last_name?.[0]?.toUpperCase() || ""}
//                   </div>
//                 )}
//               </div>

//               <div className="user-dropdown-wrapper">
//                 <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
//                   <DropdownToggle
//                     tag="span"
//                     className="badge-dropdown badge-profile cursor-pointer"
//                   >
//                     <span className="d-none d-md-inline">{fullName()}</span>
//                   </DropdownToggle>
//                   <DropdownMenu>
//                     <DropdownItem onClick={(e) => handleOperation(e, "profile")}>
//                       My Profile
//                     </DropdownItem>
//                     <DropdownItem divider />
//                     <DropdownItem onClick={(e) => handleOperation(e, "logout")}>
//                       Logout
//                     </DropdownItem>
//                   </DropdownMenu>
//                 </Dropdown>
//               </div>
//             </div>
//           </div>

//           {/* === MOBILE (below md) === */}
//           <div className="d-inline d-md-none ms-1">
//             <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
//               <DropdownToggle tag="span" className="cursor-pointer">
//                 <i
//                   className="bi bi-three-dots-vertical"
//                   style={{ fontSize: "24px", color: "red"}}
//                 ></i>
//               </DropdownToggle>
//               <DropdownMenu end>
//                 <DropdownItem
//                   data-bs-toggle="modal"
//                   data-bs-target="#exampleModal"
//                 >
//                   <img src={SubscriptionIcon} alt="Subscription" className="me-2" />
//                   Subscription
//                 </DropdownItem>
//                 <DropdownItem>
//                   <Bell /> Notifications
//                 </DropdownItem>
//                 <DropdownItem onClick={(e) => handleOperation(e, "profile")}>
//                   My Profile
//                 </DropdownItem>
//                 <DropdownItem divider />
//                 <DropdownItem onClick={(e) => handleOperation(e, "logout")}>
//                   Logout
//                 </DropdownItem>
//               </DropdownMenu>
//             </Dropdown>
//           </div>
//        </div>
//         </div>
//       </div>

//       {/* subscription Modal HTML */}
//       <div
//         className="modal fade subscription-popup"
//         id="exampleModal"
//         tabIndex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h1
//                 className="modal-title adjustment fs-5"
//                 id="exampleModalLabel"
//               >
//                 My Subscription(s)
//               </h1>

//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="modal-body p-0">
//               <div className="sub-popup-card">
//                 <h2 className="sub-popup-title">Active Subscription Plan</h2>
//                 <ul className="sub-popup-content">
//                   <li>Plan <span>Expiry</span></li>

//                   {subscriptions.length > 0 ? (
//                     <>
//                       {subscriptions.map((item, i) => (
//                         <li key={i}>
//                           <span className="gold-btn">
//                             <img src={GoldIcon} alt="Plan" /> {item.plan.title}
//                           </span>{" "}
//                           <span>{item.expiry_date}</span>
//                         </li>
//                       ))}

//                       <li>
//                         <a href="/admin/plans" className="btn btn-block">
//                           Upgrade Plan
//                         </a>
//                       </li>
//                     </>
//                   ) : (
//                     <li>
//                       <a href="/admin/plans" className="btn btn-block">
//                         Buy a plan
//                       </a>
//                     </li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>

//         <ConfirmLogoutModal
//           isOpen={modalOpen}
//           toggle={toggleModal}
//           onConfirm={logout}
//         />
//       </div>
//     </>
//   )
// });

export default DashboardHeader;
